import type { AvailableLocale } from '@/features/locale'

export interface LocaleItem {
  value: AvailableLocale
  name: string
  icon: string
  alt: string
}

export const LOCALE_ITEMS: readonly LocaleItem[] = [
  {
    value: 'en',
    name: 'ENG',
    icon: new URL('@/assets/svg/lang_en.svg', import.meta.url).href,
    alt: 'English',
  },
  {
    value: 'ru',
    name: 'RUS',
    icon: new URL('@/assets/svg/lang_ru.svg', import.meta.url).href,
    alt: 'Русский',
  },
] as const
